<sub-header [isModal]="true" [windowHash]=windowHash *ngIf="isLoaded()"></sub-header>
<ng-container *ngIf="isLoaded()">
  <p-scrollPanel styleClass="custombar1" [style]="{width: '100%', height: '80vh'}">
    <div cdkTrapFocus [cdkTrapFocusAutoCapture]="true" class="container-fluid" appFocusControl>
      <!--div class="row">
            <div class="col-12">

                <strong class="text-center"><i class="fas fa-search" aria-hidden="true"></i>
                    {{searchSettings.titleSearch}} </strong>

            </div>
        </div-->
      <div class="row" *ngIf="withVisibleParameters()">
        <div class="alert alert-info text-center col-12">{{ 'SearchGeneric.select.filters' | translate }}</div>
        <div class="col-12">
          <form id="formFilter" novalidate="novalidate" #element>
            <!-- FILTROS-->
            <!-- CAMPO DE TIPO TEXTO y mas-->
            <ng-container tabindex="0" *ngFor="let filter of searchSettings.parametersDefinition; let i = index">
              <formElement [model]="filters" id="''{{filter.jsonField}}''" [fieldConfig]="createFieldConfig(filter,i)"
                #elementChild>
              </formElement>
            </ng-container>
            <!-- FIN FILTROS -->
            <!-- INICIO DE VALORES FIJOS OCULTOS-->
            <ng-container *ngIf="this.context.valuesDepends">
              <ng-container *ngFor="let hiddenKey of this.context.valuesDepends.keys(); let i = index">
                <input #elementChild id="{{hiddenKey}}" type="hidden" class=""
                  [ngModel]="this.context.valuesDepends.get(hiddenKey)" />
              </ng-container>
            </ng-container>
            <!-- FIN DE VALORES FIJOS OCULTOS-->
            <div class="col-12 m-t-md m-b-sm">
              <button appDebounceClick #elementChild type="submit" class="btn btn-primary btn-xs  float-right m-b-md"
                (debounceClick)="loadSearchResult()"><i class="fas fa-search"></i> {{ 'General.search.text' | translate
                }}</button>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive" *ngIf="!isLoadedResult ()">
            <table class="table table-hover">
              <thead>
                <tr>
                  <!--<th *ngFor="let col of searchColumns; let num=index"
                    class="{{col.typeColumn?col.typeColumn+'TH':''}}"> {{col.description}}</th>-->
                  <ng-container *ngFor="let col of searchColumns">
                    <th *ngIf="col.visibility" class="{{col.typeColumn?col.typeColumn+'TH':'HTML'}}">
                      {{col.description}} </th>
                  </ng-container>

                <tr>
              </thead>
              <tbody>
                <tr>
                  <td [attr.colspan]="searchColumns.length">No se han cargado datos</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="alert" [ngClass]="(errorActions || processStatus === ProcessStatus.ABORTED) ?
              'alert-warning':
              (processStatus === ProcessStatus.FINISHED) ? 'alert-success' : 'alert-info'" role="alert"
            *ngIf="currentStep == 2">
            <div class="row">
              <div class="col-12">
                <span><i class="fas fa-1-5x fa-info-circle m-r-md" aria-hidden="true"></i> {{ getProcessMessage() }}
                </span>
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-6">
                <span>{{'MultiTaskAction.Tasks.Processed' | translate}} </span>{{executedActions}}
              </div>
              <div class="col-6" *ngIf="errorActions">
                <span>{{'Signature.Massive.Tasks.Error' | translate}} </span>{{errorActions}}
              </div>
            </div>
            <div class="row m-t-sm">
              <div class="col-12">
                <p-progressBar [value]="progressPercentage"></p-progressBar>
              </div>
            </div>
          </div>
          <p-overlayPanel #processMsg>
            <div class="alert alert-danger" role="alert" [innerHTML]="actionMessage"></div>
          </p-overlayPanel>
          <div class="table-responsive" *ngIf="isLoadedResult ()">
            <p-table [columns]="searchColumns" [value]="(currentStep === 2)? getSelectedObjects(): resultSearch"
              class="table table-striped table-hover" [paginator]="withVisibleParameters()" [rows]="10"
              [rowsPerPageOptions]="[10,25,50]" [scrollable]="false" responsiveLayout="scroll" #myTable>
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngIf="searchConfig?.multiSelection" class="col-icon text-left">
                    <p-checkbox *ngIf="currentStep !== 2" [binary]="true" [(ngModel)]="allSelected"
                      (ngModelChange)="changeAllSelection()">
                    </p-checkbox>
                  </th>
                  <ng-container *ngFor="let col of columns">
                    <th *ngIf="col.visibility" class="{{col.typeColumn?col.typeColumn+'TH':'HTML'}}">
                      {{col.description}} </th>
                  </ng-container>
                  <!-- cabecera columna de botones-->
                  <th *ngIf="rowActions && rowActions.length > 0" class="action-column-2">
                  </th>
                  <th style="width:35px"></th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-rowData>
                <tr [ngStyle]="(currentStep === 1 )?{cursor: 'pointer'}:{}"
                  (mouseover)="(currentStep === 2) ? showActionMessage(rowData, $event, processMsg) : undefined"
                  (mouseout)="(currentStep === 2) ? processMsg.hide() :undefined">
                  <td *ngIf="searchConfig?.multiSelection">
                    <input *ngIf="currentStep === 1" type="checkbox" [(ngModel)]="rowData.selected" />
                    <span *ngIf="currentStep === 2" class="d-inline-block">
                      <a [class]="getStatusIcon(rowData)"></a>
                    </span>
                  </td>
                  <ng-container *ngFor="let dataCol of searchColumns">
                    <!-- columna ENABLED-->
                    <td *ngIf="dataCol?.visibility&&rowData?.enabled"
                      (click)="(currentStep === 1) ? select(rowData) : undefined"
                      (keyup.enter)="(currentStep === 1 && (!searchConfig || !searchConfig.multiSelection)) ? select(rowData) : undefined"
                      class="{{(dataCol.typeColumn=='STRING'||dataCol.typeColumn=='TEXT'||dataCol.typeColumn=='LONGTEXT'||dataCol.typeColumn=='PARAGRAPH')?'HTML':(dataCol.typeColumn=='NUMBER'?'INTEGER':dataCol.typeColumn)}}"
                      [ngClass]="!dataCol.typeColumn ? 'withoutFormat' : ''">
                      <ng-container *ngIf="dataCol.typeColumn">&nbsp; <formatDataValue *ngIf="dataCol?.typeColumn"
                          [type]="(dataCol.typeColumn=='STRING'||dataCol.typeColumn=='TEXT'||dataCol.typeColumn=='LONGTEXT'||dataCol.typeColumn=='PARAGRAPH')?'HTML':(dataCol.typeColumn=='NUMBER'?'INTEGER':dataCol.typeColumn)"
                          [value]="rowData.content[dataCol.identifier]?.value" [maxDecimals]="2"> </formatDataValue>
                      </ng-container>
                      <ng-container *ngIf="!dataCol.typeColumn"> <span *ngIf="!this.mappingObject"
                          [innerHTML]="rowData.content[dataCol.jsonFields[0]]?.value"></span>
                        <span *ngIf="this.mappingObject"
                          [innerHTML]="rowData.content[dataCol.identifier]?.value"></span>
                      </ng-container>
                    </td>
                    <!-- columna DISABLED-->
                    <td class="text-muted" *ngIf="dataCol.visibility&&!rowData?.enabled">
                      <ng-container *ngIf="dataCol.typeColumn">
                        <formatDataValue *ngIf="dataCol?.typeColumn"
                          [type]="(dataCol.typeColumn=='STRING'||dataCol.typeColumn=='TEXT'||dataCol.typeColumn=='LONGTEXT'||dataCol.typeColumn=='PARAGRAPH')?'HTML':(dataCol.typeColumn=='NUMBER'?'INTEGER':dataCol.typeColumn)"
                          [value]="rowData.content[dataCol.identifier]?.value" [maxDecimals]="2"> </formatDataValue>
                      </ng-container>
                      <ng-container *ngIf="!dataCol.typeColumn">
                        <span *ngIf="!this.mappingObject" class="text-muted"
                          [innerHTML]="rowData.content[dataCol.jsonFields[0]]?.value"></span>
                        <span class="text-muted" *ngIf="this.mappingObject"
                          [innerHTML]="rowData.content[dataCol.identifier]?.value"></span>
                      </ng-container>
                    </td>
                  </ng-container>
                  <!-- columna de botones-->
                  <td *ngIf="rowActions && rowActions.length > 0" class="action-column-2">
                    <div class="btn-group">
                      <ng-container *ngFor="let action of rowActions">
                        <button class="btn  btn-primary btn-sm t-action-button" tabindex="{{ tabindex }}"
                          title="{{ action.buttonTextKey | translate}}" type="button"
                          (click)="executeRowAction(action,rowData?.singleValue)"
                          [attr.disabled]="(rowData?.enabled&&isActiveRowAction(action,rowData?.singleValue )) ? null: 'disabled'">
                          <i [ngClass]="action.imageClass" aria-hidden="true"></i>
                        </button>
                      </ng-container>
                    </div>
                  </td>
                  <td style="width:30px">
                    <ng-container *ngIf="!rowData?.enabled">
                      <p-overlayPanel #errTooltip appendTo="body" [showTransitionOptions]="'1000ms'"
                        [hideTransitionOptions]="'500ms'" [dismissable]="true" [showCloseIcon]="true"
                        styleClass="searchgeneric">
                        <div class="alert alert-danger" role="alert">
                          <ul class="plyca-error-list">
                            <li *ngFor="let error of rowData?.singleValue?.validationResult?.errors"
                              class="m-t-xs m-l-xs">
                              <div class="text-doc text-spacing">
                                <i *ngIf="error.type === 'FATAL'" class="fas fa-lg fa-exclamation-circle text-danger"
                                  aria-hidden="true"></i>
                                <i *ngIf="error.type === 'ERROR'" class="fas fa-lg fa-exclamation-triangle text-danger"
                                  aria-hidden="true"></i>
                                <i *ngIf="error.type === 'WARNING'"
                                  class="fas fa-lg fa-exclamation-triangle text-warning" aria-hidden="true"></i>
                                <div class="d-inline ml-1 textoerror" [innerHTML]="error.message"></div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </p-overlayPanel>
                      <span (click)="errTooltip.toggle($event)"><i class="fas fa-exclamation-circle text-danger fa-lg"
                          aria-hidden="true"></i>
                      </span>
                    </ng-container>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr>
                  <td [attr.colspan]="columns.length"> {{ 'General.noData' | translate }} </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
      <!-- <div class="row m-b-lg">
        <div class="col-12">
          <button *ngIf="searchConfig.actionCfg && currentStep === 1" type="button"
            class="btn btn-primary btn-xs  float-right" data-dismiss="modal" (click)="executeActions()">
            <i class="fa fa-check" aria-hidden="true"></i>{{ 'Actions.execute' | translate }}</button>
          <button *ngIf="searchConfig.multiSelection && !searchConfig.actionCfg" type="button"
            class="btn btn-primary btn-xs  float-right" data-dismiss="modal" (click)="acceptMultipleSelection()">
            <i class="fa fa-check" aria-hidden="true"></i>{{ 'General.accept' | translate }}</button>
          <button type="button" class="btn btn-secondary btn-xs  float-left" data-dismiss="modal" tabindex="0"
            (click)="cancel()">
            <i class="fas fa-times" aria-hidden="true"></i> {{ 'General.cancel' | translate }}</button>
        </div>
      </div> -->
    </div>
  </p-scrollPanel>
</ng-container>